var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNewsCardIconWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_75874_27117)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_75874_27117",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 30,
    height: 30
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H30V30H0V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_75874_27117)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.75 5H5.83333C4.74698 5 3.82068 5.69672 3.47667 6.66667H1.25C0.559635 6.66667 0 7.2263 0 7.91667V22.0833C0 23.6942 1.30583 25 2.91667 25H28.75C29.4404 25 30 24.4404 30 23.75V6.25C30 5.55964 29.4404 5 28.75 5ZM2.5 22.0833V9.16667H3.33333V22.0833C3.33333 22.3131 3.14641 22.5 2.91667 22.5C2.68693 22.5 2.5 22.3131 2.5 22.0833ZM27.5 22.5H5.80323C5.82271 22.3639 5.83333 22.2248 5.83333 22.0833V7.5H27.5V22.5ZM8.95833 16.25H16.0417C16.3868 16.25 16.6667 15.9702 16.6667 15.625V10.625C16.6667 10.2798 16.3868 10 16.0417 10H8.95833C8.61318 10 8.33333 10.2798 8.33333 10.625V15.625C8.33333 15.9702 8.61318 16.25 8.95833 16.25ZM10.4167 12.0833H14.5833V14.1667H10.4167V12.0833ZM8.33333 19.375V18.125C8.33333 17.7798 8.61318 17.5 8.95833 17.5H16.0417C16.3868 17.5 16.6667 17.7798 16.6667 18.125V19.375C16.6667 19.7202 16.3868 20 16.0417 20H8.95833C8.61318 20 8.33333 19.7202 8.33333 19.375ZM18.3333 19.375V18.125C18.3333 17.7798 18.6132 17.5 18.9583 17.5H24.375C24.7202 17.5 25 17.7798 25 18.125V19.375C25 19.7202 24.7202 20 24.375 20H18.9583C18.6132 20 18.3333 19.7202 18.3333 19.375ZM18.3333 11.875V10.625C18.3333 10.2798 18.6132 10 18.9583 10H24.375C24.7202 10 25 10.2798 25 10.625V11.875C25 12.2202 24.7202 12.5 24.375 12.5H18.9583C18.6132 12.5 18.3333 12.2202 18.3333 11.875ZM18.3333 15.625V14.375C18.3333 14.0298 18.6132 13.75 18.9583 13.75H24.375C24.7202 13.75 25 14.0298 25 14.375V15.625C25 15.9702 24.7202 16.25 24.375 16.25H18.9583C18.6132 16.25 18.3333 15.9702 18.3333 15.625Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_75874_27117"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewsCardIconWhite);
export default __webpack_public_path__ + "static/media/News_card_icon_white.d2279eb060473d7b574739ef529385f2.svg";
export { ForwardRef as ReactComponent };